$(function (){
    //Trees Section
    copyTree();
    setInterval(function (){
        copyTree();
    },5000)
    function copyTree(){
        if($(".trees-container").length > 0){
            let item = '<div class="images-tree" id="tree-all">\n' +
                '    <div class="animate__animated animate__fadeIn animate__delay-2s z-in-3"><img src="https://cdn.shopify.com/s/files/1/2713/5040/files/outside.svg" alt="1,000 trees Outside Tree" class="outside left"/> </div>\n' +
                '    <div class="animate__animated animate__fadeInUp animate__delay-1s z-in-2"><img src="https://cdn.shopify.com/s/files/1/2713/5040/files/inside.svg" alt="global reforestation initiative created to captureas much carbon as we can." class="inside left"/> </div>\n' +
                '    <div class="animate__animated animate__fadeInUp animate__fast z-in-1"><img src="https://cdn.shopify.com/s/files/1/2713/5040/files/center-tree.svg" alt="Every month, we plant an average of 1,000 trees in the Kiss the Hippo Forest – a global reforestation initiative created to captureas much carbon as we can." class="center"/> </div>\n' +
                '    <div class="animate__animated animate__fadeInUp animate__delay-1s z-in-2"><img src="https://cdn.shopify.com/s/files/1/2713/5040/files/inside.svg" alt="global reforestation initiative created to captureas much carbon as we can right" class="inside right"/> </div>\n' +
                '    <div class="animate__animated animate__fadeIn animate__delay-2s z-in-3"><img src="https://cdn.shopify.com/s/files/1/2713/5040/files/outside.svg" alt="1,000 trees Outside Tree Right" class="outside right"/> </div>\n' +
                '</div>';
            $(".trees-container").empty();
            $(item).clone().removeAttr('id').css('display','flex').appendTo('.trees-container')
        }
    }
    $(".jump-to-btn").on("click",function (e){
        e.preventDefault();
        const jmp = $(this).attr("data-jump");
        if(jmp !== "" && jmp !== undefined){
            console.log(jmp);
            let scrollDiv = document.getElementById(jmp).offsetTop
            console.log(scrollDiv);
            window.scrollTo({
                top: scrollDiv - 90,
                behavior: "smooth"
            })
        }
    })
    //Trees Section--
})